import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
  Plus,
  Package,
  Truck,
  Calendar,
  Users,
  ShoppingBag,
  ChevronDown
} from "lucide-react";
import { usePermissions } from "@/hooks/usePermissions";

interface NewRecordDropdownProps {
  onNavigate?: (section: string, intent?: string) => void;
}

export const NewRecordDropdown = ({ onNavigate }: NewRecordDropdownProps) => {
  const { canAccess } = usePermissions();

  const handleItemClick = (section: string, intent?: string) => {
    if (onNavigate) {
      onNavigate(section, intent);
    }
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button size="sm" className="bg-gradient-primary shadow-primary">
          <Plus className="h-4 w-4 mr-2" />
          Novo Registro
          <ChevronDown className="h-4 w-4 ml-2" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent 
        align="end" 
        className="w-56 bg-background border shadow-lg z-50"
      >
        {canAccess('logistics:loan_create') && (
        <DropdownMenuItem 
          onClick={() => handleItemClick('loans', 'new-emprestimo')}
          className="cursor-pointer"
        >
          <Plus className="h-4 w-4 mr-2" />
          Novo Empréstimo
        </DropdownMenuItem>
        )}
        
        {canAccess('logistics:loan_return') && (
        <DropdownMenuItem 
          onClick={() => handleItemClick('loans', 'new-recolhimento')}
          className="cursor-pointer"
        >
          <Package className="h-4 w-4 mr-2" />
          Novo Recolhimento
        </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem 
          onClick={() => handleItemClick('rentals', 'new-rental')}
          className="cursor-pointer"
        >
          <Calendar className="h-4 w-4 mr-2" />
          Nova Locação
        </DropdownMenuItem>
        
        {canAccess('logistics:loan_create') && (
        <DropdownMenuItem 
          onClick={() => handleItemClick('loans', 'new-saida')}
          className="cursor-pointer"
        >
          <Truck className="h-4 w-4 mr-2" />
          Nova Saída
        </DropdownMenuItem>
        )}
        
        <DropdownMenuSeparator />
        
        <DropdownMenuItem 
          onClick={() => handleItemClick('customers', 'new-customer')}
          className="cursor-pointer"
        >
          <Users className="h-4 w-4 mr-2" />
          Novo Cliente
        </DropdownMenuItem>
        
        <DropdownMenuItem 
          onClick={() => handleItemClick('products', 'new-product')}
          className="cursor-pointer"
        >
          <ShoppingBag className="h-4 w-4 mr-2" />
          Novo Produto
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};